import React from 'react';
import {OrderType} from "../../../../services/Api/types";
import MultistorePlaceCardBadge from "./MultistorePlaceCardBadge";
import OrderTypeIcon from "../../../../components/Common/OrderTypeIcon";

interface Props {
    orderType: OrderType;
}

const MultistorePlaceCardOrderType = ({orderType}: Props) => {
    return <MultistorePlaceCardBadge transparent circle icon={<OrderTypeIcon orderType={orderType}/>}/>;
}

export default MultistorePlaceCardOrderType;